// extracted by mini-css-extract-plugin
export default {"container":"bu4yz","list":"APnxo","event":"vMxHi","title":"c-HAI","chevron":"bNHEJ","info":"us7oE","time":"v9KdV"};